import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=d31b98ee&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d31b98ee')) {
      api.createRecord('d31b98ee', component.options)
    } else {
      api.reload('d31b98ee', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=d31b98ee&", function () {
      api.rerender('d31b98ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HMtB83I6YR7n/JS/comp/FavElement.vue"
export default component.exports